import { BaseDto } from "@/shared/dtos/base-dto";

export class recordatorio_cita_log extends BaseDto {
  public id_solicitud: number = 0;
  public tipo_recordatorio: string = "";
  public telefono: string = "";
  public estado_envio: string = "";
  public manychat_response: string = "";
  public created_at: Date | null = null;

  constructor(data?: any) {
    super();
    if (!data) return;
    this.copy(data);
    if (data.created_at) this.created_at = new Date(data.created_at);
  }
}
